import React from "react";
import linkedInLogo from "../../assets/about/linked-in.png";
import { Link } from "react-router-dom";
import { motion } from "framer-motion";

function TeamMember({ index, name, role, description }) {
    return (
        <motion.div
            className="flex flex-col mr-10 self-stretch px-5 my-auto light-title text-2xl sm:text-5xl font-medium max-md:mt-10 max-md:max-w-full"
            initial={{ opacity: 0, translateX: index == (0 | 2 | 4) ? 100 : -100 }}
            whileInView={{ opacity: 1, translateX: 0 }}
            transition={{ duration: 0.5, delay: 0.5, type: "spring" }}
            viewport={{ once: true }}
        >
            <h3 className="mt-10 leading-10 light-title capitalize max-md:max-w-full">Meet the {role}
                <a href={"https://www.linkedin.com/company/expertefy/"} target="_blank" className="inline-flex ml-[20px]" rel="noreferrer">
                    <img src={linkedInLogo} className="w-[30px] h-[30px] object-cover" alt="linked-in" />
                </a>
            </h3>
            <div className="mt-8 text-xl  max-md:max-w-full">
                <span className="text-xl font-medium text-color">{name}</span>{" "}
                <span className="text-lg font-light text-color">{description}</span>
            </div>
        </motion.div>
    );
}

export default TeamMember;